import styled, { keyframes } from "styled-components";

// ANIMAÇÕES
const fadeIn = keyframes`from { opacity: 0; } to { opacity: 1; }`;
const slideDown = keyframes`
  from { 
    transform: translateY(-50px); 
    opacity: 0; 
  } to { 
    transform: translateY(0); 
    opacity: 1; 
  }
`;

// -- COMPONENTES ESTILIZADOS --

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: flex-start; /* << ALTERADO PARA POSICIONAR NO TOPO */
  z-index: 2000;
  animation: ${fadeIn} 0.3s ease-out;
  padding: 5vh 20px 20px; /* << Adiciona espaçamento no topo */
  box-sizing: border-box;
  overflow-y: auto;
`;

export const ModalContainer = styled.div`
  background: #2c2c2c; /* Cor de fundo sutilmente mais clara */
  border-radius: 12px;
  width: 100%;
  max-width: 950px; /* Aumentado para mais espaço */
  display: flex;
  flex-direction: column;
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.6);
  animation: ${slideDown} 0.5s cubic-bezier(0.25, 1, 0.5, 1); /* << NOVA ANIMAÇÃO */
  border: 1px solid rgba(255, 255, 255, 0.1);
`;

export const ModalHeader = styled.div`
  padding: 25px 35px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  h3 {
    margin: 0;
    color: #e6aa3a;
    font-size: 24px;
    font-weight: 600;
    text-shadow: 0 0 10px rgba(230, 170, 58, 0.2);
  }
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: #fff;
  font-size: 30px;
  cursor: pointer;
  opacity: 0.7;
  transition: all 0.3s;
  line-height: 1;
  &:hover {
    opacity: 1;
    transform: rotate(90deg) scale(1.1);
  }
`;

export const ModalBody = styled.div`
  padding: 25px 35px;
  overflow-y: auto; /* Garante scroll interno se necessário */
  max-height: calc(95vh - 200px); /* Evita que o corpo seja muito grande */
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 25px;
  margin-bottom: 20px;

  @media (max-width: 700px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  label {
    color: #ccc;
    font-weight: 500;
    font-size: 14px;
  }
  input {
    height: 45px;
    background: rgba(0, 0, 0, 0.3);
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: #fff;
    padding: 0 15px;
    border-radius: 6px;
    font-size: 16px;
    transition: border-color 0.3s, box-shadow 0.3s;
    &:read-only {
      background-color: rgba(0, 0, 0, 0.2);
      color: #999;
      cursor: default;
    }
  }
`;

export const PermissionsSectionTitle = styled.h4`
  color: #e6aa3a;
  margin-top: 30px;
  margin-bottom: 20px;
  font-size: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding-bottom: 15px;
`;

export const PermissionsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;

  @media (max-width: 800px) {
    grid-template-columns: 1fr;
    gap: 40px;
  }
`;

export const PermissionsBox = styled.div`
  background-color: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 25px;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.3);

  h5 {
    margin: 0 0 20px 0;
    color: #fff;
    font-size: 18px;
    font-weight: 600;
  }
`;

export const PermissionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const PermissionItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  padding: 8px;
  border-radius: 6px;
  transition: background-color 0.2s, transform 0.2s;
  user-select: none;

  &:hover {
    background-color: rgba(255, 255, 255, 0.07);
    transform: translateX(5px);
  }

  span {
    color: #ddd;
    font-size: 15px;
  }
`;

export const Checkbox = styled.div`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  border-radius: 5px;
  border: 2px solid rgba(255, 255, 255, 0.5);
  background-color: ${(props) => (props.checked ? "#e6aa3a" : "transparent")};
  transition: all 0.2s cubic-bezier(0.68, -0.55, 0.27, 1.55);
  position: relative;

  ${(props) =>
    props.checked &&
    `
    border-color: #e6aa3a;
    &::after {
      content: '✔';
      color: #111;
      font-size: 14px;
      font-weight: bold;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  `}
`;

export const ModalFooter = styled.div`
  padding: 20px 35px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  background-color: rgba(0, 0, 0, 0.2);
`;

const BaseButton = styled.button`
  border: none;
  border-radius: 6px;
  padding: 12px 28px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const CancelButton = styled(BaseButton)`
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  &:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.2);
  }
`;

export const SaveButton = styled(BaseButton)`
  background: #e6aa3a;
  color: #111;
  &:hover:not(:disabled) {
    background: #ffc300;
  }
`;
